import { render } from "./AddStrands.vue?vue&type=template&id=1d532e86"
import script from "./AddStrands.vue?vue&type=script&lang=js"
export * from "./AddStrands.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__